class FooterMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.desktopMediaQuery = window.matchMedia('(min-width: 750px)')
    this.syncState = this.syncState.bind(this)
    this.syncState()
    this.desktopMediaQuery.addEventListener('change', this.syncState)
  }

  disconnectedCallback () {
    this.desktopMediaQuery.removeEventListener('change', this.syncState)

    super.disconnectedCallback()
  }

  syncState () {
    const isDesktop = this.desktopMediaQuery.matches

    this.els.details.elements.forEach((details) => {
      details.open = isDesktop
    })
  }
}

if (!customElements.get('footer-menu')) {
  customElements.define('footer-menu', FooterMenu)
}
